import { API_BASE_URL } from "../config/apiBaseUrl";

const PORTAL_BASE = "/api/v1/automap/dealer-portal";
const ADMIN_BASE = "/api/admin/automotive";

function authHeaders() {
  return { credentials: "include" };
}

function qs(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") search.set(key, value);
  });
  const query = search.toString();
  return query ? `?${query}` : "";
}

export async function fetchDealerPerformanceSummary(dealerId, range = "last_30_days") {
  const res = await fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/performance/summary${qs({ range })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar el reporte de rendimiento.");
  return res.json();
}

export async function fetchDealerListingPerformance(dealerId, params = {}) {
  const res = await fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/performance/listings${qs(params)}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar rendimiento por publicación.");
  return res.json();
}

export async function fetchDealerLeadPerformance(dealerId, range = "last_30_days") {
  const res = await fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/performance/leads${qs({ range })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar rendimiento de leads.");
  return res.json();
}

export async function fetchDealerLeadSourceSummary(dealerId, range = "last_30_days") {
  const res = await fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/performance/sources${qs({ range })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar fuentes de leads.");
  return res.json();
}

export async function fetchDealerInventoryPerformance(dealerId, range = "last_30_days") {
  const res = await fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/performance/inventory${qs({ range })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar rendimiento de inventario.");
  return res.json();
}

export async function fetchDealerTrialPerformance(dealerId) {
  const res = await fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/performance/trial`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar rendimiento del trial.");
  return res.json();
}

export async function exportDealerPerformanceReport(dealerId, range = "last_30_days") {
  const res = await fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/performance/export${qs({ range })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo exportar el reporte.");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `automap-reporte-${dealerId}.csv`;
  anchor.click();
  URL.revokeObjectURL(url);
}

export async function postDealerPerformanceEvent(dealerId, eventType, metadata = {}) {
  return fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${encodeURIComponent(dealerId)}/performance/events`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ eventType, ...metadata }),
    }
  );
}

export async function fetchAdminDealerAnalytics(params = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/analytics/dealers${qs(params)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar analytics de concesionarios.");
  return res.json();
}

export async function fetchAdminDealerPerformance(dealerId, range = "last_30_days") {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/dealers/${encodeURIComponent(dealerId)}/performance${qs({ range })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar rendimiento del concesionario.");
  return res.json();
}
